'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$175(ps$92) {
  this.a6Z = null;
  this.a6Z = ps$92;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$175 as $c_Lmealorama_jsonCodecs$package$$anon$175 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$175.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$175;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$175() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$175 as $h_Lmealorama_jsonCodecs$package$$anon$175 };
$h_Lmealorama_jsonCodecs$package$$anon$175.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6Z.a.length;
});
$p.g = (function(i) {
  return this.a6Z.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$175 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$175, "mealorama.jsonCodecs$package$$anon$175", ({
  Js: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$175 as $d_Lmealorama_jsonCodecs$package$$anon$175 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$175.js.map
